import React from 'react';
import ReactDOM from 'react-dom';
import Firebase from 'firebase';
import { DataTable } from 'react-data-components';
import {
    Button, Modal, ModalHeader, ModalBody, ModalFooter, Card, CardImg, CardText, CardBlock,
    CardTitle, CardSubtitle
} from 'reactstrap';
import Maps from './maps'
import DataItem from './dataItem'
import Select from 'react-select';


var FileSaver = require("downloadjs");
var loadImage = require("blueimp-load-image");



export default class data extends React.Component {
    constructor() {
        super();
        this.state = {
            form: "",
            versions: [],
            version: "",
            arrData: [],
            disponible: true
        }
        this.renderListForms = this.renderListForms.bind(this);
        this.renderListVersions = this.renderListVersions.bind(this);
        this.renderRegistros = this.renderRegistros.bind(this);
        this.setCSV = this.setCSV.bind(this);
        this.ConvertToCSV = this.ConvertToCSV.bind(this);
        this.renderTabla = this.renderTabla.bind(this);
        this.renderDetail = this.renderDetail.bind(this);
        this.deleteReg = this.deleteReg.bind(this);
    }

    componentWillMount() {
        var formRef = Firebase.database().ref("forms");
        var dataRef = Firebase.database().ref("saved").child(localStorage.client_id);
        dataRef.on('value', snap => {
            if (snap.val()) {
                var forms = [];
                Object.keys(snap.val()).map(form => {
                    formRef.child(form).once('value').then(resp => {
                        if (resp.val()) {
                            forms.push({ value: form, name: resp.val().name })
                            this.setState({ listForms: forms })
                        }
                    });
                })
            }
        })
    }

    ConvertToCSV(objArray) {
        var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        var str = '';
        var line = '';
        var head = array[0];
        for (var index in array[0]) {
            line += index + ';';
        }
        line = line.slice(0, -1);
        str += line + '\r\n';


        for (var i = 0; i < array.length; i++) {
            var line = '';


            for (var index in array[i]) {
                line += array[i][index] + ';';
            }

            line = line.slice(0, -1);
            str += line + '\r\n';
        }
        var name;
        this.state.listForms.map((list) => {
            if (list.value === this.state.form) {
                name = list.name;
            }
        })
        FileSaver(str, name + "_" + this.state.version + ".csv", "text/csv;charset=utf-8");
    }

    componentWillUpdate(prevState, nextState) {
        if (nextState.form !== this.state.form) {
            var dataRef = Firebase.database().ref("saved").child(localStorage.client_id).child(nextState.form);
            dataRef.once("value").then(snap => {
                this.setState({ versions: Object.keys(snap.val()) })
            })
        } else if (nextState.version !== this.state.version) {
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextState.form + "/" + nextState.version + "/raw/data");
            dataRef.orderByChild("global/date/device")
                .on('value', snap => {
                    var options = [];
                    snap.forEach(function (childSnapshot) {
                        options.push(childSnapshot.val())
                    });
                    this.setState({ registros: options })
                })
        } else if (nextState.count !== this.state.count) {
            var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + nextState.form + "/" + nextState.version + "/raw/data");
            dataRef.orderByChild("global/date/device")
                .on('value', snap => {
                    var options = [];
                    snap.forEach(function (childSnapshot) {
                        options.push(childSnapshot.val())
                    });
                    this.setState({ registros: options })
                })
        }
    }

    DateToFormattedString(d) {
        var yyyy = d.getFullYear().toString();
        var mm = (d.getMonth() + 1).toString();
        var dd = d.getDate().toString();
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return yyyy + "/" + (mm[1] ? mm : "0" + mm[0]) + "/" + (dd[1] ? dd : "0" + dd[0]) + " " + (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    deltaFormatted(d) {
        var hh = d.getHours().toString();
        var mn = d.getMinutes().toString();
        return (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]);
    };

    setCSV(titles, data) {
        var arrObjs = [];
        data.map((fila) => {
            var obj = {};
            titles.map((titulo, index) => {
                if (typeof (fila[index]) === "object") {
                    switch (Object.keys(fila[index])[0]) {
                        case "lat":
                            obj[titulo] = fila[index].lat + "|" + fila[index].lon;
                            break;
                        case "image":
                            obj[titulo] = fila[index].url;
                            break;
                        case "device":
                            var device = new Date(fila[index].device);
                            var deviceDate = this.DateToFormattedString(device);
                            var server = new Date(fila[index].server);
                            var serverDate = this.DateToFormattedString(server);
                            obj[titulo] = deviceDate;
                            break;
                        case "email":
                            obj[titulo] = fila[index].rut;
                            break;
                        default:
                            break;
                    }
                }
                else {
                    obj[titulo] = fila[index];
                }

            })
            arrObjs.push(obj);
        })
        this.ConvertToCSV(arrObjs)
    }

    deleteReg(id) {
        const contex = this;
        var logRef = Firebase.database().ref("log/" + localStorage.client_id + "/");
        var dataRef = Firebase.database().ref("saved/" + localStorage.client_id + "/" + this.state.form + "/" + this.state.version + "/raw/");
        dataRef.child("data").child(id).remove();
        dataRef.child('count').once("value").then(resp => {
            var count = (resp.val() - 1);
            dataRef.child('count').set(count).then(resp => {
                contex.setState({ count: count, showModalDelete: false });
                var id = Firebase.database().ref().child('log').push().key;
                logRef.child(id).set({
                    admin: localStorage.email,
                    timestamp: Firebase.database.ServerValue.TIMESTAMP,
                    action: "delete",
                    target: {
                        type: "registro",
                        id: id
                    }
                });
            });
        })
    }

    renderTabla(titles, data) {
        var arrObjs = [];
        var titulos = [];
        titles.unshift("Información extra")
        titles.push("Eliminar")
        titles.map((t) => {
            titulos.push({ title: t, prop: t })
        })
        data.reverse().map((fila) => {
            var obj = {};
            fila.push({ "delete": "eliminar" })
            fila.unshift({ "obj": "todo" });
            titles.map((titulo, index) => {
                if (typeof (fila[index]) === "object") {
                    switch (Object.keys(fila[index])[0]) {
                        case "lat":
                            var gps = { lat: fila[index].lat, lon: fila[index].lon };
                            obj[titulo] = fila[index].lat === 0 && fila[index].lon === 0 ? "No disponible" : <a style={{ cursor: "pointer", color: "#39b2d5" }} onClick={() => this.setState({ showModalGps: true, gps: gps })}>Ver mapa</a>
                            break;
                        case "image":
                            obj[titulo] = <a style={{ cursor: "pointer", color: "#39b2d5" }} onClick={() => { this.setState({ showModalPhoto: true, photoUrl: fila[index].url, photoName: fila[index].image }); this.setImagen(fila[index].url) }}>Ver Imagen</a>
                            break;
                        case "device":
                            var correct = new Date(fila[index].server + (fila[index].device - fila[index].sent))
                            var correctDate = this.DateToFormattedString(correct);
                            var device = new Date(fila[index].device);
                            var deviceDate = this.DateToFormattedString(device);
                            var server = new Date(fila[index].server);
                            var serverDate = this.DateToFormattedString(server);
                            obj[titulo] = fila[index].sent ? correctDate : deviceDate;
                            break;
                        case "email":
                            obj[titulo] = fila[index].name;
                            break;
                        case "obj":
                            obj[titulo] = <a style={{ cursor: "pointer", color: "#4dbd74" }} onClick={() => { this.setState({ showModalDetails: true, detail: fila }) }} > <i className="fa fa-info-circle" aria-hidden="true"></i> Detalles</a>;
                            break;
                        case "delete":
                            obj[titulo] = <button className="btn btn-danger" onClick={() => { this.setState({ idReg: fila[1], showModalDelete: true }) }} style={{ cursor: "pointer" }}>
                                <i className="fa fa-trash" aria-hidden="true"></i>
                            </button>;
                            break;
                        default:
                            break;
                    }
                }
                else {
                    obj[titulo] = fila[index];
                }

            })
            arrObjs.push(obj);
        })
        return (
            <DataTable
                style={{ margin: "0" }}
                keys="id"
                columns={titulos}
                initialData={arrObjs}
                initialPageLength={15}
                initialSortBy={{ prop: titles[0].prop, order: 'descending' }}
                pageLengthOptions={[5, 20, 50, 100]}
            />
        )
    }

    renderRegistros() {
        if (this.state.registros) {
            var titles = [];
            var data = [];
            //titulos globales
            Object.keys(this.state.registros[0].global).map((tt, index) => {
                if (tt === "key") {
                    titles.unshift(tt);
                } else {
                    titles.push(tt);
                }
            });
            //titulos de formularios
            Object.keys(this.state.registros[0].results).map((tt) => {
                titles.push(tt);
            });
            //datos formulario
            Object.values(this.state.registros).map((r) => {
                var subData = [];
                Object.values(r).map((e, i) => {
                    if (Object.keys(r)[i] !== "extra" && Object.keys(r)[i] !== "form") {
                        Object.values(e).map((f, index) => {
                            if (Object.keys(e)[index] === "key") {
                                subData.unshift(f)
                            } else {
                                subData.push(f)
                            }
                        })
                    }
                })
                data.push(subData)
            })
            if (this.state.arrData) {
                var jsonObject = JSON.stringify(this.state.arrData);
            }
            return (
                <div>
                    <button
                        id="download"
                        type="button"
                        className="btn btn-outline-success"
                        onClick={() => this.setCSV(titles, data)}
                        style={{ position: "absolute", marginTop: "-38px", right: "28%", cursor: "pointer", display: "none" }}
                    >
                        Descargar CSV
                        <i className="fa fa-download" aria-hidden="true"></i>
                    </button>
                    <div style={{ margin: "0" }}>
                        {this.renderTabla(titles, data)}
                    </div>
                </div >
            )
        }
    }

    renderListForms() {
        if (this.state.listForms) {
            var options = []
            this.state.listForms.map((list) => {
                options.push({ label: list.name, value: list.value })
            })
            return (
                <Select
                    style={{ width: "200px", marginRight: "5px" }}
                    name="form-field-name"
                    className="Select Select--single is-clearable is-searchable has-value"
                    value={this.state.form}
                    options={options}
                    onChange={(e) => { this.setState({ form: e.value, version: -1 }) }}
                />
            )
        } else {
            return (
                <Select
                    style={{ width: "200px", marginRight: "5px" }}
                    name="form-field-name"
                    className="Select Select--single is-clearable is-searchable has-value"
                    value={this.state.form}
                    options={options}
                />
            )
        }
    }

    renderListVersions() {
        var options = [];
        (this.state.versions).map((version, index) => {
            options.push({ label: version, value: version })
        })
        return (
            <Select
                style={{ width: "200px" }}
                name="form-field-name"
                className="Select Select--single is-clearable is-searchable has-value"
                value={this.state.version}
                options={options}
                onChange={(e) => { this.setState({ version: e.value }) }}
            />
        )
    }

    renderDetail() {
        var device;
        var deviceDate;
        var server;
        var serverDate;
        var sent;
        var sentDate;
        var user;
        var correct;
        var correctDate;
        var delta;
        var deltaDate;
        if (this.state.detail) {
            this.state.detail.map((f) => {
                if (typeof (f) === "object") {
                    switch (Object.keys(f)[0]) {
                        case "device":
                            correct = new Date(f.server + (f.device - f.sent))
                            correctDate = this.DateToFormattedString(correct);
                            device = new Date(f.device);
                            deviceDate = this.DateToFormattedString(device);
                            server = new Date(f.server);
                            serverDate = this.DateToFormattedString(server);
                            delta = Math.abs(new Date((f.server + (f.device - f.sent))) - new Date(f.device));
                            deltaDate = Math.floor((delta / 1000) / 60);
                            if (f.sent) {
                                sent = new Date(f.sent);
                                sentDate = this.DateToFormattedString(sent);
                            } else {
                                sentDate = "registro anterior a actualización";
                            }
                            break;
                        case "email":
                            user = f;
                            break;
                        default:
                            break;
                    }
                }
            })
            return (
                <div className="col-md-12">
                    <div className="form-group row">
                        <div className="col-md-6">
                            <img src="public/img/avatar.png" />
                        </div>
                        <div className="col-md-6">
                            {
                                user ?
                                    <div>
                                        <h4>{user.name}</h4>
                                        <p>
                                            <i className="fa fa-envelope" aria-hidden="true"></i> {user.email}
                                            <br />
                                            <i className="fa fa-user" aria-hidden="true"></i> {user.rut}
                                            <br />
                                            <i className="fa fa-phone-square" aria-hidden="true"></i> {user.number ? user.number : "No ingresado"}
                                        </p>
                                    </div >
                                    :
                                    ""
                            }
                        </div>
                    </div>
                    {deltaDate > 10 ? <p>El usuario tiene un desfase de {deltaDate} minutos.</p> : ""}
                    <div className="card">
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">Fecha de toma del registro: <b style={{ position: "absolute", right: "10%" }}>{correctDate}</b></li>
                            <li className="list-group-item">Fecha de recepción del registro: <b style={{ position: "absolute", right: "10%" }}>{serverDate}</b> </li>
                        </ul>
                    </div>
                </div >
            )
        }
    }

    setImagen(url) {
        loadImage(
            url,
            (img) => {
                if (img.type === "error") {
                    this.setState({ pruebaImagen: true, disponible: false })
                    return 0;
                } else {
                    this.setState({ pruebaImagen: true, disponible: true })
                    this.refs.imagen.appendChild(img);
                    return 0;
                }
            },
            {
                orientation: true,
                maxWidth: 470
            }
        );
    }

    render() {
        return (
            <div className="animated fadeIn">
                <div className="row">
                    <div className="card col-md-12">
                        <div className="card-block">
                            <div className="row">
                                <div className="col-sm-5">
                                    <h4 className="card-title mb-0">{localStorage.client_id}</h4>
                                    <div className="small text-muted">Registros</div>
                                </div>
                                <div className="col-sm-7 hidden-sm-down">
                                    <div className="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                                        <div className="btn-group mr-3" data-toggle="buttons" aria-label="First group">
                                            {
                                                this.state.version ?
                                                    <button
                                                        style={{ marginRight: "5px", cursor: "pointer", borderRadius: "5px" }}
                                                        type="button"
                                                        className="btn btn-outline-success"
                                                        onClick={() => { var l = document.getElementById('download'); l.click(); }}
                                                    >
                                                        Descargar CSV
                                                    <i className="fa fa-download" aria-hidden="true"></i>
                                                    </button>
                                                    :
                                                    ""
                                            }
                                            {
                                                this.renderListForms()
                                            }
                                            {"  "}
                                            {
                                                this.renderListVersions()
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="chart-wrapper">
                                    {
                                        this.renderRegistros()
                                    }
                                </div>
                            </div>
                            <Modal isOpen={this.state.showModalGps} toggle={() => { this.setState({ showModalGps: false }) }} className="modal-dialog modal-lg" >
                                <ModalHeader toggle={() => { this.setState({ showModalGps: false }) }}>
                                    Ubicación auditor
                            </ModalHeader>
                                <ModalBody>
                                    {this.state.gps ? <Maps lat={this.state.gps.lat} lon={this.state.gps.lon} /> : ""}
                                </ModalBody>
                            </Modal>
                            <Modal isOpen={this.state.showModalDetails} toggle={() => { this.setState({ showModalDetails: false }) }} className="modal-dialog" >
                                <ModalHeader toggle={() => { this.setState({ showModalDetails: false }) }}>
                                    Información extra del Registro
                                </ModalHeader>
                                <ModalBody>
                                    {this.renderDetail()}
                                </ModalBody>
                            </Modal>
                            <Modal isOpen={this.state.showModalPhoto} toggle={() => { this.setState({ showModalPhoto: false }) }} className="modal-dialog" >
                                <ModalHeader toggle={() => { this.setState({ showModalPhoto: false }) }}>
                                    {this.state.photoName}
                                </ModalHeader>
                                {this.state.pruebaImagen ?
                                    <ModalBody>
                                        <div ref="imagen" style={{ maxWidth: "470px" }} ></div>
                                        {this.state.disponible === false ?
                                            <center>
                                                <h1>Imagen aún no disponible</h1>
                                                <i className="fa fa-file-image-o" aria-hidden="true" style={{ fontSize: "300px" }}></i>
                                                <h5>A la espera del envio de datos del usuario.</h5>
                                            </center>
                                            : ""
                                        }
                                    </ModalBody>
                                    :
                                    ""
                                }
                            </Modal>
                            <Modal isOpen={this.state.showModalDelete} toggle={() => this.setState({ showModalDelete: false })} className="modal-dialog">
                                <ModalHeader toggle={() => this.setState({ showModalDelete: false })}>Eliminar registros</ModalHeader>
                                <ModalBody>
                                    ¿Está seguro que desea eleminar este registro?
                                </ModalBody>
                                <ModalFooter>
                                    <button className="btn btn-outline-danger" onClick={() => this.deleteReg(this.state.idReg)}>Eliminar</button>{' '}
                                    <button className="btn btn-outline-secundary" onClick={() => this.setState({ showModalDelete: false })}>Cancel</button>
                                </ModalFooter>
                            </Modal>
                            {/* <div className="card-footer">
                            <ul>
                                <li>
                                    <div className="text-muted">Visits</div>
                                    <strong>29.703 Users (40%)</strong>
                                    <Progress className="progress-xs mt-2" color="success" value="40" />
                                </li>
                                <li className="hidden-sm-down">
                                    <div className="text-muted">Unique</div>
                                    <strong>24.093 Users (20%)</strong>
                                    <Progress className="progress-xs mt-2" color="info" value="20" />
                                </li>
                                <li>
                                    <div className="text-muted">Pageviews</div>
                                    <strong>78.706 Views (60%)</strong>
                                    <Progress className="progress-xs mt-2" color="warning" value="60" />
                                </li>
                                <li className="hidden-sm-down">
                                    <div className="text-muted">New Users</div>
                                    <strong>22.123 Users (80%)</strong>
                                    <Progress className="progress-xs mt-2" color="danger" value="80" />
                                </li>
                                <li className="hidden-sm-down">
                                    <div className="text-muted">Bounce Rate</div>
                                    <strong>40.15%</strong>
                                    <Progress className="progress-xs mt-2" color="primary" value="40" />
                                </li>
                            </ul>
                        </div> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/data/data.js